module.exports = __webpack_public_path__ + "img/log-out.8d509764.svg";